<script setup>
import { ref } from "vue";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import { COUNTRY_OPTIONS } from "../analysisOptions";

defineProps({
  label: { type: String, default: "Country code(s)" },
});
const modelValue = defineModel({ type: Array, required: true });
const multiselectRef = ref(null);
</script>

<template>
  <div class="filter-block">
    <label class="form-label text-sm fw-semibold d-flex justify-content-between mb-1">
      <span>{{ label }}</span>
      <span>
        <a href="javascript:;" class="text-xs" @click="multiselectRef.selectAll()">Select all</a>
        <span class="text-secondary">&nbsp;|&nbsp;</span>
        <a href="javascript:;" class="text-xs" @click="multiselectRef.clear()">Clear</a>
      </span>
    </label>
    <Multiselect ref="multiselectRef" v-model="modelValue" mode="multiple" :searchable="true"
      :close-on-select="false" :hide-selected="false" :options="COUNTRY_OPTIONS" :track-by="['name', 'value']"
      label="label" placeholder="Select countries">
      <template v-slot:option="{ option, isSelected }">
        <input type="checkbox" class="form-check-input me-2" style="pointer-events: none"
          :checked="isSelected(option)" tabindex="-1" />
        <span>{{ option.label }}</span>
      </template>
    </Multiselect>
  </div>
</template>
